"use client";
import icon from "../../assets/icon.png";
import one from "../../assets/1.png";
import two from "../../assets/2.png";
import three from "../../assets/3.png";
import four from "../../assets/4.png";
import five from "../../assets/5.png";

import Header from "../layout/Header";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllNewsArticles } from "../../firebase";
import { NewsArticle } from "../../types";

import ApprovedUsers from "./ApprovedUsers";
import ExistingAthletes from "./existingAthletes";
import Foundations from "./foundations";
import Logos from "./logos";
import Stats from "./stats";
import BeyondStats from "./beyondStats";
import Founder from "./founder";
import Testimonials from "./testimonials";
import Footer from "../layout/footer";
import Socials from "./socials";
import Events from "../portal/events";
import { addSubscriber } from "../../firebase";
import FriendsOfWattlenest from "./FriendsOfWattlenest";

export default function Example() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState<
    "idle" | "loading" | "success" | "exists" | "error"
  >("idle");

  // Add state for news articles
  const [latestNews, setLatestNews] = useState<NewsArticle[]>([]);
  const [loading, setLoading] = useState(true);

  // Fetch latest news articles
  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        setLoading(true);
        const allArticles = await getAllNewsArticles();
        // Filter published articles and sort by date (newest first)
        const publishedArticles = allArticles
          .filter((article) => article.published)
          .sort((a, b) => b.createdAt - a.createdAt)
          // Take only the latest 3 articles
          .slice(0, 3);

        setLatestNews(publishedArticles);
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestNews();
  }, []);

  // Format date helper function
  const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !email.includes("@")) {
      return;
    }

    setSubscribeStatus("loading");

    try {
      const result = await addSubscriber(email);

      if (result === "exists") {
        setSubscribeStatus("exists");
      } else {
        setSubscribeStatus("success");
        setEmail("");
      }

      // Reset status after 3 seconds
      setTimeout(() => {
        setSubscribeStatus("idle");
      }, 3000);
    } catch (error) {
      console.error("Error subscribing:", error);
      setSubscribeStatus("error");

      // Reset error status after 3 seconds
      setTimeout(() => {
        setSubscribeStatus("idle");
      }, 3000);
    }
  };

  return (
    <div className="bg-white">
      <div className="pb-10">
        <Header></Header>
      </div>
      <main>
        <div className="relative isolate">
          {/* Add this div for the background logo */}
          <div className="absolute -bottom-24 right-0 overflow-hidden pointer-events-none opacity-20 z-0">
            <img src={icon} alt="" className="w-200 h-200" />
          </div>

          <div className="overflow-hidden">
            <div className="mx-auto max-w-7xl px-6 pt-32 pb-32 sm:pt-60 lg:px-8 lg:pt-32">
              <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div className="relative w-full lg:max-w-xl lg:shrink-0 xl:max-w-2xl">
                  <h1 className="text-5xl font-black font-poppins tracking-tight text-gray-900 sm:text-7xl">
                    We are a community that connects business and sport.
                  </h1>
                  <p className="mt-8 mb-5 text-lg font-josefin font-medium text-pretty text-gray-500 sm:max-w-md sm:text-xl/8 lg:max-w-none">
                    Welcome to the WattleNest- a community that connects
                    business and sport to build stronger, healthier and all
                    inclusive communities.
                  </p>
                  <Socials />
                  <div className="mt-10 flex items-center gap-x-6">
                    <a
                      href="#athletes"
                      className="rounded-md bg-gold px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Athletes
                    </a>
                    <a
                      href="#subscribe"
                      className="text-sm/6 font-semibold text-gray-900"
                    >
                      Join the Community <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </div>
                <div className="mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
                  <div className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                    <div className="relative">
                      <img
                        alt=""
                        src={one}
                        className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
                    </div>
                  </div>
                  <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
                    <div className="relative">
                      <img
                        alt=""
                        src={two}
                        className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
                    </div>
                    <div className="relative">
                      <img
                        alt=""
                        src={three}
                        className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
                    </div>
                  </div>
                  <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
                    <div className="relative">
                      <img
                        alt=""
                        src={four}
                        className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
                    </div>
                    <div className="relative">
                      <img
                        alt=""
                        src={five}
                        className="aspect-2/3 w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-gray-900/10 ring-inset" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section id="subscribe" className="py-0 w-full bg-gold">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 py-32">
            <div className="mx-auto max-w-4xl lg:text-center">
              <h2 className="font-semibold text-4xl text-white">
                “Sport has the power to change the world. It has the power to
                inspire. It has the power to unite people in a way that little
                else does.”{" "}
                <span className="text-gray-800">Nelson Mandela</span>
              </h2>
              <p className="mt-8 text-lg font-josefin font-medium text-white sm:text-xl/8">
                We connect athletes to business to create meaningful and lasting
                relationships that provide athletes support and business unique
                exposure opportunities. Subscribe to our newsletter to learn
                about events, athletes and engage with the community.
              </p>
              <form
                className="mx-auto mt-10 flex max-w-lg gap-x-4"
                onSubmit={handleSubscribe}
              >
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  required
                  placeholder="Enter your email"
                  autoComplete="email"
                  className="min-w-0 flex-auto rounded-md bg-white/9 px-3.5 py-2 text-base text-black outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-white sm:text-sm/6"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={subscribeStatus === "loading"}
                />
                <button
                  type="submit"
                  className="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white disabled:opacity-75"
                  disabled={subscribeStatus === "loading"}
                >
                  {subscribeStatus === "loading"
                    ? "Subscribing..."
                    : "Subscribe"}
                </button>
              </form>
              {subscribeStatus === "success" && (
                <p className="mt-3 text-sm text-white font-medium">
                  Thanks for subscribing! We'll keep you updated.
                </p>
              )}
              {subscribeStatus === "exists" && (
                <p className="mt-3 text-sm text-white font-medium">
                  This email is already subscribed to our newsletter.
                </p>
              )}
              {subscribeStatus === "error" && (
                <p className="mt-3 text-sm text-white font-medium">
                  Something went wrong. Please try again.
                </p>
              )}
              <p className="text-white mt-10">
                <em>
                  Despite being a sports obsessed Nation, over 40% of our elite
                  athletes live on or below the poverty line.
                </em>
              </p>
            </div>
          </div>
        </section>

        {/* Athletes Section */}
        <section id="athletes" className="py-24 bg-gray-50 px-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center">
              <h2 className="text-base font-semibold leading-7 text-gold">
                Athletes
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Our Athletes
              </p>
            </div>
            <div className="mt-16">
              <ApprovedUsers />
            </div>
          </div>
        </section>

        {/* Partners & Supporters Section */}
        <section id="partners" className="py-24 px-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center">
              <h2 className="text-base font-semibold leading-7 text-gold">
                Partners & Supporters
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Our Valued Partners
              </p>
            </div>
            <div className="flex justify-center">
              <Logos />
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="py-24 bg-gray-100 px-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto lg:text-center">
              <h2 className="text-left font-semibold leading-7 text-gold mb-10">
                About Wattlenest
              </h2>

              <p className="mt-2 mb-5 text-left text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Sport holds a profound power that transcends mere physical
                competition.
              </p>
              <p className="text-left">
                WattleNest is a thriving community of over 160 athletes across
                50+ different sports, united by a shared commitment to
                purpose-driven impact. With a national reach, we connect
                athletes, businesses, and changemakers to create meaningful
                opportunities that go beyond competition. From Olympians and
                Paralympians to emerging talent, our network is built on the
                values of collaboration, leadership, and giving back. Whether
                it's through mentorship, corporate engagement, or grassroots
                initiatives, WattleNest empowers athletes to leverage their
                platform for social good while helping organizations drive
                purpose-led change.
                <br></br>
                <br></br>
                Despite being a sports obsessed Nation, over 40% of our elite
                athletes live on or below the poverty line resulting in 42% of
                our athletes aged between 18 and 34 suffering from poor mental
                health due to their financial predicament.<br></br>
                <br></br> We don't believe affordability should be a barrier for
                anyone to reach their full potential and know that investment in
                sport strengthens community. <br></br>
                <br></br>We invite you to be part of our journey to Champion our
                Champions and help leave a lasting legacy.
              </p>
            </div>
            <FriendsOfWattlenest />
          </div>
        </section>

        {/* About Section */}
        <section className="py-24 bg-gray-50 px-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto lg:text-center">
              <Founder></Founder>
            </div>
          </div>
        </section>

        <section className="py-24 bg-goldlight px-4">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto lg:text-center">
              <Foundations></Foundations>
            </div>
          </div>
        </section>

        {/* Impact Section */}
        <section id="impact" className="py-24 bg-gray-100">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto lg:text-center"></div>
            <Stats></Stats>
          </div>
        </section>

        {/* Beyond Sport Section */}
        <section id="impact" className="py-24 bg-goldlight">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto lg:text-center"></div>
            <BeyondStats></BeyondStats>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-24 bg-gray-50">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center"></div>
            <Testimonials />
          </div>
        </section>

        {/* News Section */}
        <section id="news" className="py-24 bg-white">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center mb-12">
              <h2 className="text-base font-semibold leading-7 text-gold">
                Podcast, News & Updates
              </h2>
              <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Hear the latest form us
              </p>
            </div>

            {loading ? (
              <div className="flex justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gold"></div>
              </div>
            ) : latestNews.length === 0 ? (
              <p className="text-center text-gray-500">
                No news articles available
              </p>
            ) : (
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
                {latestNews.map((article) => (
                  <div
                    key={article.id}
                    className="flex flex-col overflow-hidden rounded-lg shadow-lg"
                  >
                    {article.imageURL && (
                      <div className="flex-shrink-0">
                        <img
                          className="h-48 w-full object-cover"
                          src={article.imageURL}
                          alt={article.title}
                        />
                      </div>
                    )}
                    <div className="flex flex-1 flex-col justify-between bg-white p-6">
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gold">
                          {formatDate(article.createdAt)}
                        </p>
                        <Link to={`/news/${article.slug}`} className="mt-2 block">
                          <p className="text-xl font-semibold text-gray-900">
                            {article.title}
                          </p>
                          <p className="mt-3 text-base text-gray-500 line-clamp-3">
                            {article.body
                              .replace(/<[^>]+>/g, "")
                              .substring(0, 150)}
                            {article.body.length > 150 ? "..." : ""}
                          </p>
                        </Link>
                      </div>
                      <div className="mt-6">
                        <Link
                          to={`/news/${article.slug}`}
                          className="text-base font-semibold text-gold hover:text-gold-600"
                        >
                          Read more →
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="mt-10 text-center">
              <Link
                to="/news"
                className="rounded-xl bg-goldlight px-3.5 py-2.5 text-sm font-semibold text-gold shadow-sm hover:bg-gold-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
              >
                View All News
              </Link>
            </div>
          </div>
        </section>

        {/* Enquiry Section */}
        <section id="enquiry" className="py-24 bg-gray-50">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Have a question?
              </h2>
              <p className="mt-4 text-lg leading-8 text-gray-600">
                We'd love to hear from you. Reach out and we'll get back to you
                as soon as possible.
              </p>
              <div className="mt-10">
                <a
                  href="mailto:rachelcondos@wattlenest.com.au?subject=Wattlenest%20Enquiry"
                  className="rounded-md bg-gold px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gold-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
                >
                  Make Enquiry
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
